export const CROWDCAST = 'www.crowdcast.io';

export enum E_CALENDAR {
  ICAL = 'ical',
  GOOGLE = 'google',
  OUTLOOK = 'outlook',
  OUTLOOK_ONLINE = 'outlookonline',
  YAHOO = 'yahoo',
}

export const CALENDARS = [
  { type: E_CALENDAR.ICAL, displayName: 'iCal' },
  { type: E_CALENDAR.GOOGLE, displayName: 'Gmail' },
  { type: E_CALENDAR.OUTLOOK, displayName: 'Outlook' },
  { type: E_CALENDAR.OUTLOOK_ONLINE, displayName: 'Outlook live' },
  { type: E_CALENDAR.YAHOO, displayName: 'Yahoo' },
];

export enum E_SHARE_TYPE {
  FACEBOOK = 'facebook',
  TELEGRAM = 'telegram',
  TWITTER = 'twitter',
  LINKEDIN = 'linkedin',
}

export const SHARE_TYPES = [
  { type: E_SHARE_TYPE.FACEBOOK, displayName: 'Facebook' },
  { type: E_SHARE_TYPE.TELEGRAM, displayName: 'Telegram' },
  { type: E_SHARE_TYPE.TWITTER, displayName: 'Twitter' },
  { type: E_SHARE_TYPE.LINKEDIN, displayName: 'LinkedIn' },
];

export const ORGANIZER_NAME = 'Republic';
export const ORGANIZER_EMAIL = 'team@republic.co';
export const ADD_TO_CALENDAR_URL = 'http://addtocalendar.com/atc/';
export const SEO_DESCRIPTION_LENGTH = 160;
